import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-0",
    items: this.plotOrderItemTemplateInfos,
    columns: this.columns,
    storageKey: "plotOrderItemTemplateListWidget"
  }, {
    paperQuality: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        mode: "flex",
        options: this.constructPaperQualityOptions(),
        modelValue: item.plotPropertiesPaperQuality,
        "onUpdate:modelValue": ($event: any) => ((item.plotPropertiesPaperQuality) = $event)
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
    ]),
    isInColor: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        mode: "flex",
        options: this.constructColorOptions(),
        modelValue: item.plotPropertiesIsInColor,
        "onUpdate:modelValue": ($event: any) => ((item.plotPropertiesIsInColor) = $event)
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
    ]),
    margin: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        mode: "flex",
        options: this.constructMarginOptions(),
        modelValue: item.plotPropertiesMargin,
        "onUpdate:modelValue": ($event: any) => ((item.plotPropertiesMargin) = $event)
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
    ]),
    mirror: _withCtx(({ item }) => [
      _createVNode(_component_CheckBox, {
        mode: "flex",
        modelValue: item.plotPropertiesMirror,
        "onUpdate:modelValue": ($event: any) => ((item.plotPropertiesMirror) = $event)
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    scale: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        mode: "flex",
        options: this.constructScaleOptions(),
        modelValue: item.plotPropertiesScale,
        "onUpdate:modelValue": ($event: any) => ((item.plotPropertiesScale) = $event)
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
    ]),
    count: _withCtx(({ item }) => [
      _createVNode(_component_NumberInput, {
        mode: "flex",
        modelValue: item.plotPropertiesCount,
        "onUpdate:modelValue": ($event: any) => ((item.plotPropertiesCount) = $event)
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    deliveryTarget: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        mode: "flex",
        options: this.deliveryTargetOptions,
        modelValue: item.deliveryAddressId,
        "onUpdate:modelValue": ($event: any) => ((item.deliveryAddressId) = $event),
        selectClass: this.getDeliveryTargetCss(item)
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "selectClass"])
    ]),
    actions: _withCtx(({ item }) => [
      (this.plotOrderItemTemplateInfos.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-sm btn-outline-danger me-1",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('plot.template.item.list.deleteToolTip'),
            onClick: ($event: any) => (this.removePosition(item))
          }, _hoisted_3, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-outline-primary me-1",
        "data-bs-toggle": "tooltip",
        title: _ctx.$t('plot.template.item.list.addToolTip'),
        onClick: ($event: any) => (this.addPosition(item))
      }, _hoisted_6, 8, _hoisted_4)
    ]),
    _: 1
  }, 8, ["items", "columns"]))
}